import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import FunnelStepTypes from "../pages/funnel-step/types";
import PathHelper from "./path-helper";
import { APP_NAVIGATION, LOCALE } from "./constants";

// Utility function to delete a specific cookie
const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
};

// Utility function to delete all cookies
export const clearAllCookies = () => {
  const cookies = document.cookie.split("; ");
  cookies.forEach((cookie) => {
    const cookieName = cookie.split("=")[0];
    deleteCookie(cookieName);
  });
};

export const PushResetApp = () => ({
  type: FunnelStepTypes.RESET_APP,
});

const useSignOut = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;

  const signOut = useCallback(
    ({ isNavigate = true } = {}) => {
      // Clear local storage
      // localStorage.removeItem("jwtToken");
      // localStorage.removeItem("refreshToken");
      localStorage.removeItem("expiresAt");
      localStorage.removeItem("gender");
      localStorage.removeItem("userAnswers");

      // Clear all cookies
      clearAllCookies();

      // Clear Redux storage
      dispatch(PushResetApp());

      if (isNavigate) {
        const path = PathHelper(APP_NAVIGATION.SINI, currentLocale);
        navigate(`${path.next}`);
      }
    },
    [navigate, dispatch, currentLocale]
  );

  return signOut;
};

export default useSignOut;
